import { Component } from '@angular/core';
import { SpanLinkComponent } from './span-link.component';
import { CoverageModalOptions } from './models/coverage-modal-options.model';
import { CoverageService } from './coverage.service';
import { CoverageLegend } from './models/coverage-legend.model';
import { SpanLinkModal } from './span-link-modal.component';

@Component({
    selector: 'coverage-modal',
    template: require('./coverage-modal.component.html'),
    providers: [CoverageService]
})
export class CoverageModal extends SpanLinkModal {
    public get options(): CoverageModalOptions {
        return <CoverageModalOptions>this.modalOptions;
    }

    public get modalHeader(): string {
        let title: string;

        // Only displays the package name in the title if there is one package
        if (this.options.showPackageModalHeader &&
            this.options.product.length === 1) {
            let claimPayout: string = this.productClaimPayout;

            title = `${this.options.product[0].packageName} Coverages`;

            if (claimPayout) {
                title += ` - ${claimPayout}`;
            }
        }

        return title || 'Coverages';
    }

    public get productClaimPayout(): string {
        let claimPayoutType: string = '';

        if (this.options.product.length === 1 &&
            this.options.product[0].package &&
            this.options.product[0].package.claimPayout) {
            claimPayoutType = this.options.product[0].package.claimPayout.join(', ');
        }

        return claimPayoutType || '';
    }

    public get wasPurchased(): boolean {
        return this.options.wasPurchased;
    }

    public get showDocLink(): boolean {
        return this.options.showDocLink;
    }

    public get showHeader(): boolean {
        return this.options.showHeader;
    }

    public get docLink(): string {
        if (this.options.product.length > 0) {
            return this.options.product[0].docLink;
        }

        return null;
    }

    public onOkayClicked(event: Event): void {
        this.modalDialogInfo.close();
    }

    constructor(private coverageService: CoverageService) {
        super();
    }

    public getLegendData(): CoverageLegend[] {
        return this.coverageService.getCoverageLegendIconsForProducts(this.options.product, true);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/coverage-modal.component.ts